/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { InlineEdit } from '@components/v2/InlineEdit';
import { Toggle } from '@components/v2/Toggle';
import './ConfigureTabStyles.scss';
const namespace = 'features.settings.component_questions';
export default function ConfigureTab({ questionSet, onUpdate }) {
    const handleDescriptionUpdate = (e) => {
        const target = e.target;
        const newDescription = target.textContent || '';
        if (onUpdate && newDescription !== questionSet.description) {
            void onUpdate(questionSet.id, 'description', newDescription);
        }
    };
    const handleActiveToggle = (e) => {
        if (onUpdate) {
            void onUpdate(questionSet.id, 'active', e.target.checked);
        }
    };
    return (React.createElement("div", { className: "configure-tab" },
        React.createElement("div", { className: "configure-tab__form" },
            React.createElement("div", { className: "configure-tab__field" },
                React.createElement("label", { className: "configure-tab__label" },
                    translate('description_label', { namespace }),
                    ":"),
                React.createElement(InlineEdit, { as: "div", className: "configure-tab__value configure-tab__value--textarea", onBlur: handleDescriptionUpdate }, questionSet.description || '')),
            React.createElement("div", { className: "configure-tab__field configure-tab__field--toggle" },
                React.createElement("label", { className: "configure-tab__label", htmlFor: "active-toggle" },
                    translate('active_label', { namespace }),
                    ":"),
                React.createElement(Toggle, { id: "active-toggle", checked: questionSet.active, onChange: handleActiveToggle, "aria-label": translate('active_label', { namespace }) })))));
}
